import api from './api'

class UsersService {
    getUsers() {
        return api.get('/users')
    }

    createUser(form) {
        return api.post('/users', form)
    }

    updateUser(form) {
        return api.put(`/users/${form.id}`, form)
    }

    deleteUser(id) {
        return api.delete(`/users/${id}`)
    }
}

export default new UsersService()